/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {SnapRotate as SnapRotate1} from './player/snap-rotate.js';
import {AudioListener} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {ActivateFinalStep} from './components/activate-final-step.js';
import {ActivateObject} from './components/activate-object.js';
import {CompleteObjective} from './components/complete-objective.js';
import {GameComplete} from './components/game-complete.js';
import {JumpScare} from './components/jump-scare.js';
import {PlaySound} from './components/play-sound.js';
import {RayTypeSwitcher} from './components/ray-type-switcher.js';
import {SetMenuHeight} from './components/set-menu-height.js';
import {ShowDialog} from './components/show-dialog.js';
import {UnlockDoor} from './components/unlock-door.js';
import {GameFlowController} from './core/game-flow-controller.js';
import {GameManager} from './core/game-manager.js';
import {TextsManager} from './core/texts-manager.js';
import {TimeManager} from './core/time-manager.js';
import {Door} from './interactions/door.js';
import {InteractableTrigger} from './interactions/interactable-trigger.js';
import {Interactable} from './interactions/interactable.js';
import {Trigger} from './interactions/trigger.js';
import {TriggerTarget} from './interactions/triggerTarget.js';
import {HideHandOnGrab} from './player/hide-hand-on-grab.js';
import {Locomotion} from './player/locomotion.js';
import {WasdControlsFps} from './player/wasd-locomotion.js';
import {Captions} from './ui/captions.tsx';
import {DescriptionText} from './ui/description.tsx';
import {MainMenu} from './ui/main-menu.tsx';
import {TheEnd} from './ui/the-end.tsx';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(SnapRotate1);
engine.registerComponent(AudioListener);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(ActivateFinalStep);
engine.registerComponent(ActivateObject);
engine.registerComponent(CompleteObjective);
engine.registerComponent(GameComplete);
engine.registerComponent(JumpScare);
engine.registerComponent(PlaySound);
engine.registerComponent(RayTypeSwitcher);
engine.registerComponent(SetMenuHeight);
engine.registerComponent(ShowDialog);
engine.registerComponent(UnlockDoor);
engine.registerComponent(GameFlowController);
engine.registerComponent(GameManager);
engine.registerComponent(TextsManager);
engine.registerComponent(TimeManager);
engine.registerComponent(Door);
engine.registerComponent(InteractableTrigger);
engine.registerComponent(Interactable);
engine.registerComponent(Trigger);
engine.registerComponent(TriggerTarget);
engine.registerComponent(HideHandOnGrab);
engine.registerComponent(Locomotion);
engine.registerComponent(WasdControlsFps);
engine.registerComponent(Captions);
engine.registerComponent(DescriptionText);
engine.registerComponent(MainMenu);
engine.registerComponent(TheEnd);
/* wle:auto-register:end */
}
